// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1J5iV","rightAdornment":"Header_rightAdornment__35bJZ"};